import React from "react";
import { useTranslation } from "react-i18next";
import { purchaserInvoiceForm, recipientInvoiceForm } from "./inputsForm/InputPayFormModels";
import { FormElementModel } from "../../models/FormElementModel";
import FormInput from "../../../utils/FormInput";

interface IProps {
  register: any;
  errors: any;
}

const RecipientAndPurchaserForm: React.FC<IProps> = ({ register, errors }) => {
  const { t } = useTranslation();
  return (
    <>
      {" "}
      <h3>
        {t("dane_do_faktury")} {t("odbiorca")}
      </h3>
      <div className={"inputs-customer-invoice"}>
        {recipientInvoiceForm(register).map(
          (item: FormElementModel, index: number) => item.name && <FormInput key={index} {...item} errors={errors} />
        )}
      </div>
      <h3>
        {t("dane_do_faktury")} {t("nabywca")}
      </h3>
      <div className={"inputs-customer-invoice"}>
        {purchaserInvoiceForm(register).map(
          (item: FormElementModel, index: number) => item.name && <FormInput key={index} {...item} errors={errors} />
        )}
      </div>
    </>
  );
};

export default RecipientAndPurchaserForm;
